import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FaRegCircleDot } from "react-icons/fa6";
import { FaEdit } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { FiPlus } from "react-icons/fi";
import { convertCamelToDisplayName } from "../utils/utils.js";
import List from "./List";

function Object(props) {
  const [items, setItems] = useState([props.object]);
  const [fields, setFields] = useState(props.fields || []);
  const [objectConfig, setObjectConfig] = useState(props.object_config || []);
  const [regexString, setRegexString] = useState(props.regex || []);
  const [displayState, setDisplayState] = useState("DISPLAY");
  const [displayField, setDisplayField] = useState(
    props.fields && props.fields.length > 0 ? props.fields[0] : ""
  );
  const [formData, setFormData] = useState({ data: props.object, status: "IDLE" });

  const handleInputChange = (e) => {
    const target = e.currentTarget;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setFormData({
      data: { ...formData.data, [name]: value },
      status: "IDLE",
    });
  };

  const setListOrObjectData = async (fieldName, newList) => {
    setFormData({
      data: { ...formData.data, [fieldName]: newList },
      status: "IDLE",
    });
  };

  const validateRegex = (fieldData, regexString) => {
    try {
      const regex = new RegExp(regexString);
      return regex.test(fieldData);
    } catch (error) {
      console.error("Error validating regex: ", error);
      return false;
    }
  };

  const showEditInput = (e) => {
    setDisplayState("EDIT");
  };

  const handleEdit = (e) => {
    e.preventDefault();

    setFormData({ data: formData.data, status: "IDLE" });
    props.callback(props.field_name, formData.data);
    setDisplayState("DISPLAY")

  };

  const handleCancel = (e) => {
    setDisplayState("DISPLAY")
  };

  const getInputFields = () => {
    console.log(JSON.stringify(props.object));
    console.log("Fields = " + JSON.stringify(fields));
    return fields.map((field, x) => {
      const attributes = objectConfig.length > x && objectConfig[x]?.input_type !== "dropdown"? { size: objectConfig[x]?.size } : {};
      console.log(JSON.stringify(field));

      /* KAD added different types of fields, text and textarea Feb 14, 2025 */
      if (objectConfig.length > 0) {
        if (objectConfig[x]?.input_type === 'dropdown')  {
           return (
             <td key={field}>
               <select
                 {...attributes}
                 value={field in formData.data && formData.data[field] || ""}
                 name={field}
                 onChange={handleInputChange}
               >
               <option> </option>
               {objectConfig[x]?.values.map((value) => 
                   <option>{value}</option>
               )
               }
               </select>
             </td>
           );
        }
        if (objectConfig[x]?.input_type === 'text')  {
           return (
             <td key={field}>
               <input
                 {...attributes}
                 value={field in formData.data && formData.data[field] || ""}
                 name={field}
                 onChange={handleInputChange}
               />
             </td>
           );
        }
        if (objectConfig[x]?.input_type === 'textarea')  {
           return (
             <td width="400px" key={field}>
               <textarea
                 {...attributes}
                 cols="50"
                 value={formData.data[field] || ""}
                 name={field}
                 onChange={handleInputChange}
               />
             </td>
           );
        }
        if (objectConfig[x]?.input_type === 'list')  {
           if (objectConfig[x]?.list_fields)
               attributes["fields"] = objectConfig[x]?.list_fields;
           return (
             <td width="400px" key={field}>
                            <List
                              {...attributes}
                              list={formData.data[objectConfig[x]?.name]}
                              list_config={objectConfig[x]?.list_config}
                              field_name={objectConfig[x]?.name}
                              callback={setListOrObjectData}
                              regex={objectConfig[x]?.regex}
                            />
             </td>
           );
        }
        if (objectConfig[x]?.input_type === 'object')  {
 console.log("Passing down these fields - " + JSON.stringify(objectConfig[x]));
 console.log("Passing down these fields - " + JSON.stringify(objectConfig[x]?.object_fields));
           if (objectConfig[x]?.object_fields)
               attributes["fields"] = objectConfig[x]?.object_fields;
           return (
             <td width="400px" key={field}>
                            <Object
                              {...attributes}
                              object={objectConfig[x]?.name in formData.data?formData.data[objectConfig[x]?.name]:""}
                              object_config={objectConfig[x]?.object_config}
                              field_name={objectConfig[x]?.name}
                              callback={setListOrObjectData}
                              regex={objectConfig[x]?.regex}
                            />
             </td>
           );
        }
      }
    });
  };

  const getFieldHeaders = () => {
    return objectConfig.map((field, index) => (
      <td key={index}>
        <b>
          <i>
            <font color="#fff">{field.display_name}</font>
          </i>
        </b>
      </td>
    ));
  };

  const formattedJson = JSON.stringify(formData.data, null, "\t");
  return (
    <div className="input-with-add-preview-lists">
      {displayState === 'EDIT' && (
        <form>
          <table>
            <thead>
              <tr>{getFieldHeaders()}</tr>
            </thead>
            <tbody>
              <tr>{getInputFields()}</tr>
            </tbody>
          </table>
          <div
            style={{
              display: "flex",
              gap: "5px",
              justifyContent: "flex-start",
            }}
          >
            <button
              onClick={(e) => handleEdit(e)}
              className="primary-gradient-btn submit-btn"
            >
              Confirm
            </button>
            <button onClick={handleCancel} className="primary-gradient-btn submit-btn">
              Cancel
            </button>
          </div>
        </form>
        )
      }
      {displayState === 'DISPLAY' && (
               <pre style={{ color: 'rgb(169, 169, 169)'}}>
                        <button
                          onClick={(e) => showEditInput(e)}
                          className="plus-btn primary-gradient-btn"
                        >
                          <FaEdit />
                        </button>
                 <code>
                  {formattedJson}
                  </code>
               </pre>
       )
      }
    </div>
  );
}

export default Object;
